/**
 * Auth Watcher Component
 * 
 * Wraps the token refresh watcher hook to monitor token expiry
 * and automatically refresh tokens before they expire.
 * 
 * This component renders nothing - it's purely for side effects.
 */

import { useTokenRefreshWatcher } from '~/services/auth/hooks';

export function AuthWatcher() {
  useTokenRefreshWatcher();
  return null;
}
